import type { IWindowService } from "angular";
import { module } from "angular";

import type { IScreenService } from "./IScreenService";

const DEVICES = {
    android: "Android",
    iOS: "IPhone",
    windows: "Windows Phone",
};

export class ScreenService implements IScreenService {
    public static $inject: string[] = ["$window"];

    constructor(private readonly $window: IWindowService) {}

    public isTablet(orLarger: boolean): boolean {
        if (orLarger) {
            return this.$window.screen.width >= 768;
        }
        return this.$window.screen.width >= 768 && this.$window.screen.width <= 1024;
    }

    public isMobile(): boolean {
        return this.$window.screen.width < 768;
    }

    public isIOS(): boolean {
        return this.isMobile() && window.navigator.userAgent.includes(DEVICES.iOS);
    }

    public isAndroid(): boolean {
        return this.isMobile() && window.navigator.userAgent.includes(DEVICES.android);
    }

    public isWindows(): boolean {
        return this.isMobile() && window.navigator.userAgent.includes(DEVICES.windows);
    }

    public isInLandscapeMode(): boolean {
        if (this.$window.orientation === undefined) {
            return false;
        }
        return this.$window.orientation.valueOf() === 90;
    }

    public isMSIE() {
        return this.$window.navigator.userAgent.includes("Trident");
    }
}

module("mmServices").service("irScreenService", ScreenService);
